(function ($, Drupal, drupalSettings, once) {

  // Sep up the namespace as a function to store list of arguments in a queue.
  Drupal.eu_cookie_compliance = Drupal.eu_cookie_compliance || function () {
    (Drupal.eu_cookie_compliance.queue = Drupal.eu_cookie_compliance.queue || [])
      .push(arguments)
  };

  window.dataLayer = window.dataLayer || [];

  const defaultConsent = {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied',
    'security_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
  }

  function gtag() {
    dataLayer.push(arguments);
  }

  function getCurrentConsent() {
    let consent = { ... defaultConsent }

    consent.ad_storage = Drupal.eu_cookie_compliance.hasAgreed('marketing') ? 'granted' : 'denied';
    consent.ad_personalization = Drupal.eu_cookie_compliance.hasAgreed('marketing') ? 'granted' : 'denied';
    consent.ad_user_data = Drupal.eu_cookie_compliance.hasAgreed('marketing') ? 'granted' : 'denied';
    consent.analytics_storage = Drupal.eu_cookie_compliance.hasAgreed('statistics') ? 'granted' : 'denied';

    return consent;
  }

  const postPreferencesLoadHandler = function (response) {
    gtag('consent', 'default', getCurrentConsent());
  };
  Drupal.eu_cookie_compliance('postPreferencesLoad', postPreferencesLoadHandler);

  const postPreferencesSaveHandler = function (response) {
    gtag('consent', 'update', getCurrentConsent());
  };
  Drupal.eu_cookie_compliance('postPreferencesSave', postPreferencesSaveHandler);

})(jQuery, Drupal, drupalSettings, once);
